<template>
    <VueHighcharts :options="chartOptions" ref="pieCharts" class="chart"/>
</template>
  
<script>

import VueHighcharts from 'vue2-highcharts'  

export default {
    name: 'PieChart',
    props: {
        context: {
            type: String,
            required: true
        }
    },
    components: {
        VueHighcharts
    },
    data(){
        return {
            format: null
        }
    },
    computed:{
        chartOptions(){
            return{
                chart: {
                    type: 'pie'
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: this.chartTitleText,
                    style : {
                        fontSize: '16px',
                        fontWeight: 'normal',
                        fontFamily: 'Roboto, sans-serif'
                    }
                },
                tooltip: {
                    headerFormat: '',
                    pointFormat: '<b>{point.name}</b><br>' + '{point.revenue} <br> {point.quantity}',
                    style : {
                        fontFamily: 'Roboto, sans-serif'
                    }
                },
                plotOptions: {
                    series:{
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            distance: 20,
                            style : {
                                fontFamily: 'Roboto, sans-serif'
                            }
                        }
                    }
                },
                series: [{
                    name: this.$store.getters['get' + this.context + 'PieChartSeriesTitle'],
                    colorByPoint: true,
                    data: this.chartSeriesData
                }]
            }
        },
        chartSeriesData(){
            var seriesData = this.$store.getters['get' + this.context + 'PieChartSeriesData'].sort((a,b) => (a.y < b.y) ? 1 : (b.y < a.y) ? -1 : 0)
            seriesData = seriesData.map((data) => { 
                let nameValue = data.name
                if(this.chartTitleValue === 'countries') {
                    nameValue = this.$alvPlugin.getTranslatedCountryCode(data.name)
                }else{
                    if(this.$alvPlugin.isLangConst(data.name)){
                        nameValue = this.$t(data.name)
                    }
                }
                const isPublishing = this.context.startsWith('PublishingStatistics')
                const quantityLabel = isPublishing
                    ? this.$t('lang_GENERIC_CAPTION_NUMBER_OF_WORKS')
                    : this.$t('lang_GENERIC_CAPTION_QUANTITY')
                const quantityValue = isPublishing
                    ? this.$alvPlugin.getNumberLocalization(data.q, 'numberInteger')
                    : this.$alvPlugin.getNumberLocalization(data.q, 'number').slice(0, -3)
                return { 
                    name: nameValue,
                    y: data.y,
                    q: data.q,
                    revenue: this.$t('lang_LABEL_STATISTICS_CAPTION_REVENUE') + ': ' + this.$alvPlugin.getNumberLocalization(data.y, 'number') + ' ' + this.$store.getters.getSelectedCurrency,
                    quantity: quantityLabel + ': ' + quantityValue
                }
            })
            return seriesData
        },
        chartTitleText(){
            var title = this.$store.getters['get' + this.context + 'PieChartTitle']
            var seriesData = this.$store.getters['get' + this.context + 'PieChartSeriesData']
            if(seriesData.length == 0){
                return this.$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            }
            var titleText = '';
            if(title.text.length > 1){ 
                title.text.forEach(element => {
                    var elementText = this.$alvPlugin.isLangConst(element) ? this.$t(element) : element;
                    titleText = titleText + ' ' + elementText
                });
            }else{
                titleText = this.$alvPlugin.isLangConst(title.text[0]) ? this.$t(title.text[0]) : title.text[0];
            }
           
            return titleText;
        },
        chartTitleValue(){
            var title = this.$store.getters['get' + this.context + 'PieChartTitle'];
            return title.value
        }
    },
    mounted() {
    }
};
</script>

<style scoped>
.chart{
height: 400px;
}
</style>
